// Disorder and cohort constants for eligibility and enrollment

export const voiceDisorders = [
  'Glottic insufficiency / Presbyphonia',
  'Laryngeal Cancer',
  'Laryngitis',
  'Lesions of the vocal cord (nodule, polyp, cyst)',
  'Muscle Tension Dysphonia (MTD)',
  'Recurrent Laryngeal Papilloma (RRP)',
  'Spasmodic Dysphonia / Laryngeal Tremor',
  'Unilateral Vocal Fold Paralysis'
];

export const neurologicalDisorders = [
  "Alzheimer's, Dementia, or Mild Cognitive Impairment",
  'Amyotrophic Lateral Sclerosis (ALS)',
  "Huntington's disease",
  "Parkinson's disease"
];

export const psychiatricDisorders = [
  'Anxiety Disorder',
  'Bipolar Disorder',
  'Depression or Major Depressive Disorder'
];

export const respiratoryDisorders = [
  'Asthma',
  'Airway Stenosis (for example: bilateral vocal fold paralysis; laryngeal stenosis)',
  'Chronic Cough',
  'COPD'
];

export const cohortNames = [
  'Voice Disorders',
  'Respiratory Disorders',
  'Neurological and Neurodegenerative Disorders',
  'Mood and Psychiatric Disorders'
];
